var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkNotAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 202,
    viewBox: "0 0 201 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 201,
    height: 202,
    rx: 100,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.375 58.9167H108.875V74.9083H142.375C156.696 74.9083 168.338 86.6075 168.338 101C168.338 113.036 160.13 123.136 148.991 126.082L161.219 138.37C174.87 131.384 184.25 117.413 184.25 101C184.25 77.77 165.49 58.9167 142.375 58.9167ZM134 92.5833H115.659L132.409 109.417H134V92.5833ZM16.75 35.9392L42.7963 62.115C27.5538 68.3433 16.75 83.4092 16.75 101C16.75 124.23 35.51 143.083 58.625 143.083H92.125V127.092H58.625C44.3037 127.092 32.6625 115.393 32.6625 101C32.6625 87.6175 42.7962 76.5917 55.7775 75.1608L73.1137 92.5833H67V109.417H89.8637L108.875 128.523V143.083H123.364L156.947 176.75L167.5 166.145L27.3862 25.25L16.75 35.9392Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkNotAvailable);
export default __webpack_public_path__ + "static/media/linkNotAvailable.cd5c124d8b732e8aeda5590d61976d66.svg";
export { ForwardRef as ReactComponent };